export enum UserRole {
  VISITOR = 'visitor',
  BASIC = 'basic',
  ADMIN = 'admin',
}
